import { useSuspenseQuery } from "@tanstack/react-query";
import type { Subscription } from "@/pages/dashboard";

type SubscriptionsResponse = {
  subscriptions: Subscription[];
  jobAlertsPaused: boolean;
};

const useSubscriptions = ({ mock }: { mock?: boolean } = {}) => {
  if (mock) {
    return { data: { subscriptions: [], jobAlertsPaused: false } };
  }
  const fetchSubscriptions = (): Promise<SubscriptionsResponse> =>
    fetch("/subscriptions.json").then((res) => res.json());

  return useSuspenseQuery({
    queryKey: ["subscriptions"],
    queryFn: fetchSubscriptions,
    staleTime: 60 * 60 * 1000, // 60 minutes
  });
};

export default useSubscriptions;
